import { createStore } from "redux";
import { syncHistoryWithStore } from "react-router-redux";
import { useRouterHistory } from "react-router";
import { createHistory } from "history";
import { loadState, saveState } from "./localStorage";
import throttle from "lodash/throttle";

// import the root reducer
import rootReducer from "./reducers/index";

const persistedState = loadState();
const store = createStore(rootReducer, persistedState, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

store.subscribe(throttle(() => {
  saveState(store.getState());
}, 1000));

const appHistory = useRouterHistory(createHistory)({ queryKey: false });
export const history = syncHistoryWithStore(appHistory, store);

export default store;



/** WEBPACK FOOTER **
 ** ./src/store.js
 **/